import React from "react";
import { getUserCalendarFromCookies, useStateValue } from "../App";
import copy from "copy-to-clipboard";
import queryString from "qs";

const isUserCalendarRoute = (uid) => {
  return (
    window.location.href.includes("agenda=") &&
    typeof updatedUserCalendarCookie === "undefined"
  );
};

const isInfobarActive = (uid) => {
  if (
    typeof queryString.parse(window.location.search.replace("?", ""))
      .agenda !== "undefined"
  ) {
    return true;
  } else if (isUserCalendarRoute() && window.location.pathname.includes(uid)) {
    return true;
  }
  return false;
};

export const Infobar = (({ uid, currentYear, createCalendar, app }) => {
  const userCalendars = getUserCalendarFromCookies();

  if (userCalendars.length > 0) {
    // Get calendar item count
    var mostRecentDate = new Date(
      Math.max.apply(
        null,
        userCalendars.map((e) => {
          return new Date(e.added);
        })
      )
    );

    var userCalendar = userCalendars.filter((e) => {
      var d = new Date(e.added);
      return d.getTime() == mostRecentDate.getTime();
    })[0];
  }

  const _uid =
    userCalendars.length > 0
      ? userCalendar.uid
      : isUserCalendarRoute()
      ? uid
      : false;

  const [{ query }] = useStateValue();
  const [isActive, setIsActive] = React.useState(isInfobarActive(_uid));
  const [isCopied, setIsCopied] = React.useState(false);

  const closeInfobar = () => {
    setIsActive(false);
  };

  React.useEffect(() => {
    const _query = { ...query };
    delete _query.created;
    delete _query.date;

    const updatedQuery = queryString.stringify(_query);

    if (updatedQuery !== queryString.stringify(query)) {
      const newUrl = `${window.location.origin}${window.location.pathname}?${updatedQuery}`;
      window.history.pushState({}, "", newUrl);
    }
  }, []);

  React.useEffect(() => {
    document
      .querySelector(".search-toggle")
      .addEventListener("click", closeInfobar);

    document.getElementById('app').style.height = isActive ? (window.innerWidth < 991 ? "28rem" : "15rem") : 'unset';
    return document.removeEventListener("click", closeInfobar);
  }, [isActive]);

  React.useEffect(() => {
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  }, [isCopied]);

  // React.useEffect(() => {
  //   if (uid !== null && isUserCalendarRoute()) {
  //     setIsActive(true);
  //   }
  // }, [uid]);

  const handleCopy = (url) => {
    copy(url);
    setIsCopied(true);
  };

  const calendarUrl = 'https://jaarkalender.nl/?agenda=' + encodeURI(uid.title) + '&bekijk=' + uid.edit_hash;
  const editUrl = uid.created_by!=''?'https://jaarkalender.nl/?agenda=' + encodeURI(uid.title) + '&bewerk=' + uid.created_by:'';
  const subscribeUrl = 'https://jaarkalender.nl/?action=abonneer'+'&id=' + uid.edit_hash;


  const calendarUrlIsCurrentUrl = _uid
    ? `/agenda/bekijk/${_uid}/` === window.location.pathname
    : false;

  return (
    <>
      <button
        className="btn infobar__toggle"
        onClick={(e) => setIsActive(!isActive)}
      ></button>
      <div
        className={`infobar ${isActive ? "active" : ""}`}
        style={{
          // position: isRelative ? "relative" : "absolute",
          position: "absolute",
          height: isActive ? (window.innerWidth < 991 ? "auto" : "auto") : 0,
          paddingTop: isActive ? (window.innerWidth < 991 ? "2rem" : "1rem") : 0,
          paddingBottom: isActive ? (window.innerWidth < 991 ? "2rem" : "1rem") : 0,
        }}
      >
        <button
          className="infobar__closeBtn btn"
          onClick={(e) => setIsActive(false)}
        >
          <span className="screen-reader-text">Sluiten</span>
          <i className="fal fa-times"></i>
        </button>
        <div className="container flex">
          {uid !== false ? (
            <>

              {calendarUrl ? (
                  <div className={"inputHolder"}>
                    <div className={"title"}>
                    Link openbaar <span className={"infoButton"} data-info={"public"}><i className="fa-solid fa-circle-info"></i> Uitleg</span>
                  </div>

                  <input value={calendarUrl} readOnly type="text" />
                  <button
                    className={`btn btn--infobarCopy ${
                      isCopied ? "copied" : ""
                    }`}
                    onClick={() => handleCopy(calendarUrl)}
                  >
                    <span>Copy</span>
                  </button>

                </div>

              ) : null}


              {editUrl ? (
                  <div className={"inputHolder"}>
                    <div className={"title"}>
                      Link beheerder <span className={"infoButton"} data-info={"private"}><i className="fa-solid fa-circle-info"></i> Uitleg</span>
                    </div>
                    <input value={editUrl} readOnly type="text" />
                    <button
                        className={`btn btn--infobarCopy ${
                            isCopied ? "copied" : ""
                        }`}
                        onClick={() => handleCopy(editUrl)}
                    >
                      <span>Copy</span>
                    </button>

                  </div>
              ) : null}

              {subscribeUrl ? (
                  <>
                  <div className={"inputHolder"}>
                  <div className={"title"}>
                    Link Abonneren <span className={"infoButton"} data-info={"subscribe"}><i className="fa-solid fa-circle-info"></i> Uitleg</span>
                  </div>
                    <input value={subscribeUrl} readOnly type="text" />
                    <button
                        className={`btn btn--infobarCopy ${
                            isCopied ? "copied" : ""
                        }`}
                        onClick={() => handleCopy(subscribeUrl)}
                    >
                      <span>Copy</span>
                    </button>
                  </div>
                  <div className={"inputHolder"}>

                    <div className={"title"}>
                      Nieuwe kalender maken <span className={"infoButton"} data-info={"create"}><i className="fa-solid fa-circle-info"></i> Uitleg</span>
                    </div>
                        <a
                            className="btn btn--infobarCalendarLink"
                            href={"/maak-kalender"}
                        >
                          Maak nieuwe kalender
                        </a>

                  </div>
                  </>
              ) : null}

            </>

          ) : (
            <div className={"createHolder"}>
              <span className="icon-jaarkalender-sad" />
              <p>Je hebt nog geen items toegevoegd aan je eigen kalender</p>
              <button
                className="btn btn--infobarCalendarLink"
                onClick={() => {closeInfobar();createCalendar()}}
              >
                Maak je kalender
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
});
